import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";

let nextCheckboxGroupId = 0;

@Component({
    selector: "tr[appSaqSection2bCheckboxes]",
    templateUrl: "./section_2b_checkboxes.component.html",
    styleUrls: ["./section_2b_checkboxes.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Section2bCheckboxesComponent {
    readonly groupName = `section_2b_checkboxes_${nextCheckboxGroupId++}`;

    readonly options = [1, 2, 3, 4, 5];

    @Input()
    selectedOption: number | null = null;

    @Input()
    disabled = false;

    @Input()
    disableNotTestedOption = false;

    @Output()
    readonly selectedOptionChange = new EventEmitter<number | null>();

    onOptionSelected(option: number): void {
        if (this.isOptionDisabled(option)) {
            return;
        }

        this.selectedOption = option;
        this.selectedOptionChange.emit(option);
    }

    isOptionDisabled(option: number): boolean {
        return this.disabled || (this.disableNotTestedOption && option === 4);
    }
}
